import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "index"
};
const _hoisted_2 = {
  class: "item"
};
const _hoisted_3 = {
  class: "item-code"
};
const _hoisted_4 = {
  class: "product"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "info"
};
const _hoisted_7 = {
  class: "price",
  style: {
    "font-size": "24px"
  }
};
const _hoisted_8 = {
  class: "info-name"
};
const _hoisted_9 = {
  class: "info-skutext"
};
const _hoisted_10 = {
  class: "footer"
};
const _hoisted_11 = {
  class: "footer"
};
const _hoisted_12 = {
  class: "footer-time"
};
import CustomBar from "@/components/customBar";
import { useStore } from "@/store/index";
import { storeToRefs } from 'pinia';
import Clipboard from "clipboard";

import { showToast } from 'vant/es';
import 'vant/es/toast/style/index';
export default {
  __name: 'index',
  setup(__props) {
    const store = useStore();
    const {
      orderInfo
    } = storeToRefs(store);
    const copyToClipboard = type => {
      let text = '';
      if (type == 'expressNo') {
        text = orderInfo.value.expressNo;
      } else {
        text = orderInfo.value.orderNo;
      }
      const clipboard = new Clipboard('.btn', {
        text: () => text
      });
      clipboard.on('success', function (e) {
        showToast('复制成功');
        clipboard.destroy();
      });
      clipboard.on('error', function (e) {
        showToast('复制失败');
        clipboard.destroy();
      });
      clipboard.onClick(event);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(CustomBar), {
        title: "查看物流"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString(_unref(orderInfo).expressName) + "：" + _toDisplayString(_unref(orderInfo).expressNo) + " ", 1), _createElementVNode("div", {
        class: "copy",
        onClick: _cache[0] || (_cache[0] = $event => copyToClipboard('expressNo'))
      }, "复制 ")]), _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        class: "img",
        src: _unref(orderInfo).goodsPic,
        alt: ""
      }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "s",
        style: {
          "font-size": "18px"
        }
      }, "￥", -1)), _createTextVNode(_toDisplayString(_unref(orderInfo).priceYuan), 1)]), _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(orderInfo).goodsName), 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, _toDisplayString(_unref(orderInfo).spec), 1), _createElementVNode("div", null, "x" + _toDisplayString(_unref(orderInfo).qty), 1)])])]), _createElementVNode("div", _hoisted_10, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "footer-text"
      }, "订单编号：", -1)), _createElementVNode("div", {
        class: "footer-time copy",
        onClick: _cache[1] || (_cache[1] = $event => copyToClipboard('orderNo'))
      }, _toDisplayString(_unref(orderInfo).orderNo), 1)]), _createElementVNode("div", _hoisted_11, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "footer-text"
      }, "创建时间：", -1)), _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(orderInfo).createTime), 1)])])])], 64);
    };
  }
};